import React from "react";
import { formatMoney } from "../../shared/utilitties/formatMoney";
import { useGlobalContext } from "../../shared/context/global.context";
interface Props {
  domain: number[],
  montoText: string,
  onChangeMonto:Function,
  onFocus:Function,
  disable: boolean
}

const HeaderAdelantos = (props:Props) => {
  const {userLogged} = useGlobalContext()
  return (
    <div>
      <div className="row d-flex align-items-end">
        <div className="col-6">
          <p>Pagos programados:</p>
        </div>
        <div className="col-6 n1 d-flex justify-content-end">
          <p>
            <span>$</span>
            {formatMoney(props.domain[1])}
          </p>
        </div>
      </div>
      <div className="row d-flex align-items-end">
        <div className="col-6">
          <p>Monto a Adelantar:</p>
        </div>
        <div className="col-6 n1 d-flex justify-content-end">
          <span>$</span>
          <input
            id="Monto"
            className="text-right c3"
            value={props.montoText}
            type="text"
            onChange={(e) => props.onChangeMonto(e)}
            style={{ width: 140 }}
            onFocus={() => props.onFocus}
            disabled={props.disable || userLogged.activeDirectory}
          />
        </div>
      </div>
    </div>
  );
};

export default HeaderAdelantos;
